//scss
import "./style.scss";

//assets
import SvgRightArrowGrey from "../../../../assets/icons/js/SvgRightArrowGrey";

const ListingBreadcrumbs = ({ className = "", items = [], name, id }) => {
	return (
		<div className={"listing__breadcrumbs " + className}>
			{items.map((item, index) => {
				return (
					<div key={index}>
						<a
							aria-label="BreadCrumb"
							href={item?.link}
							className={
								"text-xsm-light " + (index === 0 ? "clr-blue" : "clr-grey")
							}
						>
							{item?.name}
						</a>

						{index + 1 !== items?.length && <SvgRightArrowGrey />}
					</div>
				);
			})}

			{/* <a href="/" className="text-xsm-light clr-blue">
				Home
			</a>
			<RightArrow />
			<a href="/search" className="text-xsm-light clr-grey">
				Search Results
			</a>*/}
			{/* <RightArrow /> */}
			<SvgRightArrowGrey />
			<a
				aria-label="LisitngId"
				href={"/listing/" + id}
				className="text-xsm-light clr-grey"
			>
				{name}
			</a>
		</div>
	);
};

export default ListingBreadcrumbs;
